import React from 'react';
import { SIZE_CLASSES } from '@/styles/classes';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
}) => {
  return (
    <div
      data-testid="loading-spinner"
      className={`animate-spin rounded-full border-b-2 border-blue-600 ${SIZE_CLASSES.spinner[size]} ${className}`}
    />
  );
};
